import { getDiameterOversize, getHeightOversize, getWidthOversize } from '../sinterringHelper'
import { isSinterringNormal } from '../profileHelper'
import { RingDetailsBuilder } from './ringDetailsBuilder'
import { Slice } from '@ringo/types'

export class SinterringRingDetailsBuilder extends RingDetailsBuilder {
    override appendAlloy() {
        this.rows.push(
            ...Array.from({ length: this.ring.dimensions.slices?.length }, (_, index) => ({
                title: index === 0 ? this.t('detailOverview.alloy') : '',
                value: this.formatAlloyLabel(this.ring.dimensions.slices?.[index], index),
            }))
        )
        return this
    }

    override appendWidth(): SinterringRingDetailsBuilder {
        super.appendWidth()
        this.rows.push({
            title: this.t('dimensions.widthOversize'),
            value: this.formatNumber(getWidthOversize(this.ring.dimensions.width, this.ring.dimensions.slices, this.ring.activeProfile as any), 'mm'),
        })
        return this
    }

    override appendHeight(): SinterringRingDetailsBuilder {
        super.appendHeight()
        this.rows.push({
            title: this.t('configuration.heightOversize'),
            value: this.formatNumber(getHeightOversize(this.ring.dimensions.height, this.ring.dimensions.slices, this.ring.activeProfile as any), 'mm'),
        })

        return this
    }

    override appendDiameter(): RingDetailsBuilder {
        super.appendDiameter()
        this.appendDiameterOversize()
        return this
    }

    private appendDiameterOversize(): SinterringRingDetailsBuilder {
        if (isSinterringNormal(this.ring.activeProfile)) {
            this.rows.push({
                title: this.t('detailOverview.diameterOversize'),
                value: this.formatNumber(getDiameterOversize(this.ring.dimensions.diameter, this.ring.activeProfile as any), 'mm'),
            })
        }

        return this
    }

    private formatAlloyLabel(slice: Slice, index: number): string {
        return index + 1 + ' - ' + slice.alloyName + ' - ' + this.formatNumber(slice.size, 'mm')
    }
}
